import {
  Alert as MantineAlert,
  AlertProps as MantineAlertProps,
} from '@mantine/core';
import {
  IconAlertCircle,
  IconAlertTriangle,
  IconCircleCheck,
  IconInfoCircle,
} from '@tabler/icons-react';
import { ReactNode } from 'react';

import styles from './Alert.module.css';

export type AlertVariant =
  'general-note' | 'intro' | 'callout' | 'warning' | 'success' | 'error';

const VARIANT_ICONS: Record<AlertVariant, ReactNode> = {
  'general-note': <IconInfoCircle size={20} stroke={2} />,
  intro: <IconInfoCircle size={20} stroke={2} />,
  callout: <IconInfoCircle size={20} stroke={2} />,
  warning: <IconAlertTriangle size={20} stroke={2} />,
  success: <IconCircleCheck size={20} stroke={2} />,
  error: <IconAlertCircle size={20} stroke={2} />,
};

export interface AlertProps extends Omit<
  MantineAlertProps,
  'variant' | 'color' | 'styles' | 'classNames' | 'style'
> {
  variant?: AlertVariant;
  /** Show icon. When true, displays variant default or custom icon. Default: true */
  withIcon?: boolean;
}

export const Alert = ({
  variant = 'general-note',
  icon,
  withIcon = true,
  children,
  ...props
}: AlertProps) => {
  const defaultIcon = VARIANT_ICONS[variant];
  const resolvedIcon = withIcon ? (icon ?? defaultIcon) : undefined;

  return (
    <MantineAlert
      unstyled
      classNames={{
        root: styles.root,
        wrapper: styles.wrapper,
        body: styles.body,
        title: styles.title,
        label: styles.label,
        message: styles.message,
        icon: styles.icon,
        closeButton: styles.closeButton,
      }}
      data-variant={variant}
      icon={resolvedIcon}
      {...props}
    >
      {children}
    </MantineAlert>
  );
};
